/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, Dec 2021
 * @flow
 */

import React, { useRef } from 'react';
import PropTypes from 'prop-types';

import Checkbox from '../../../../components/Checkbox';
import backImg from '../../../../assets/images/Fireboard/back2_red.png';
import searchIcon from '../../../../assets/images/Fireboard/search_black.png';
import Toggle from '../../../../components/Toggle';
import strings from '../../../../globalization';
import classes from './Header.module.css';

const Header = props => {
  const {
    goBack,
    stationView,
    toggleCheckbox,
    changeView,
    excludeTerminated,
    tableWithSensors,
    jobAllowsAssignment,
    assigned,
  } = props;

  return (
    <div className={classes.headerWrapper}>
      <div className={classes.headerLeftSection}>
        {window.ReactNativeWebView
          ? <img src={backImg} className={classes.backImage} alt='' onClick={goBack} />
          : null}
        <div className={classes.toggleWrapper}>
          <span className={[classes.sortOptions, classes.noMargin].join(' ')}>{strings.employeeView}</span>
          <Toggle selected={!stationView} onClick={changeView} />
          <span className={classes.sortOptions}>{strings.tableView}</span>
        </div>
      </div>
      <div className={classes.headerRightSection}>
        <div className={classes.checkboxWrapper}>
          <Checkbox checked={assigned} onChange={toggleCheckbox('assigned')} />
          <span className={classes.sortOptions}>{strings.assigned}</span>
        </div>
        <div className={classes.checkboxWrapper}>
          <Checkbox checked={jobAllowsAssignment} onChange={toggleCheckbox('jobAllowsAssignment')} />
          <span className={classes.sortOptions}>{strings.jobAllowsAssignment}</span>
        </div>
        <div className={classes.checkboxWrapper}>
          <Checkbox checked={excludeTerminated} onChange={toggleCheckbox('excludeTerminated')} />
          <span className={classes.sortOptions}>{strings.excludeTerminated}</span>
        </div>
        <div className={classes.checkboxWrapper}>
          <Checkbox checked={tableWithSensors} onChange={toggleCheckbox('tableWithSensors')} />
          <span className={classes.sortOptions}>{strings.tableWithSensors}</span>
        </div>
      </div>
    </div>
  );
};

Header.propTypes = {
  goBack: PropTypes.func.isRequired,
  stationView: PropTypes.bool,
  toggleCheckbox: PropTypes.func,
  changeView: PropTypes.func,
  excludeTerminated: PropTypes.bool,
  tableWithSensors: PropTypes.bool,
  jobAllowsAssignment: PropTypes.bool,
  assigned: PropTypes.bool,
  sortByName: PropTypes.bool,
  onChangeSortByName: PropTypes.func,
};

Header.defaultProps = {
  goBack: () => { },
  stationView: false,
  toggleCheckbox: () => { },
  changeView: () => { },
  excludeTerminated: true,
  tableWithSensors: true,
  jobAllowsAssignment: true,
  assigned: false,
  sortByName: true,
  onChangeSortByName: () => { },
};

const FilterHeader = ({ sortByName, onChangeSortByName, stationView, searchEmployeeValue, onSearchEmployee }) => {
  const inputRef = useRef();

  const onSubmit = event => {
    event.preventDefault();
    inputRef.current.blur();
  };

  return (
    <div className={classes.headerWrapper}>
      <div className={classes.toggleWrapper}>
        <span className={[classes.sortOptions, classes.noMargin].join(' ')}>{strings.sortByName}</span>
        <Toggle selected={sortByName} onClick={!stationView ? onChangeSortByName : null} />
        <span className={classes.sortOptions}>{strings.sortByPOSID}</span>
      </div>
      <div className={classes.inputWrapper}>
        <form onSubmit={onSubmit}>
          <input
            ref={inputRef}
            disabled={stationView}
            className={classes.input}
            placeholder='Search'
            value={searchEmployeeValue}
            onChange={onSearchEmployee}
          />
        </form>
        <img src={searchIcon} className={classes.searchIcon} alt='search' />
      </div>
    </div>
  );
};

FilterHeader.propTypes = {
  stationView: PropTypes.bool,
  sortByName: PropTypes.bool,
  onChangeSortByName: PropTypes.func,
  searchEmployeeValue: PropTypes.string,
  onSearchEmployee: PropTypes.func,
};

FilterHeader.defaultProps = {
  stationView: false,
  sortByName: true,
  onChangeSortByName: () => { },
  searchEmployeeValue: '',
  onSearchEmployee: () => { },
};

export {
  Header,
  FilterHeader,
};
